import 'focus-visible/dist/focus-visible'

import { I18n, I18nProvider } from '@lingui/react'
import { StaticQuery, graphql } from 'gatsby'
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowCircleDown,
  faArrowDown,
  faBars,
  faBus,
  faClock,
  faCog,
  faDirections,
  faEnvelope,
  faExternalLinkAlt,
  faInfo,
  faLanguage,
  faMap,
  faMapMarkerAlt,
  faPaperPlane,
  faParking,
  faPhoneAlt,
  faQuestion,
  faQuoteLeft,
  faQuoteRight,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  fab,
} from '@fortawesome/free-brands-svg-icons'
import { muiTheme, theme } from '../utils/theme'

import CookieConsent from './cookie-consent'
import Header from './header'
import Helmet from 'react-helmet'
import { MuiThemeProvider } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'
import { SnackbarProvider } from 'notistack'
import { ThemeProvider } from 'styled-components'
import catalogs from '../utils/catalogs'
import { css } from 'glamor'
import globals from 'globals'
import { library } from '@fortawesome/fontawesome-svg-core'
import { t } from '@lingui/macro'

library.add(
  fab,

  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowCircleDown,
  faArrowDown,
  faBars,
  faBus,
  faClock,
  faCog,
  faDirections,
  faEnvelope,
  faExternalLinkAlt,
  faFacebook,
  faInfo,
  faInstagram,
  faLanguage,
  faLinkedin,
  faMap,
  faMapMarkerAlt,
  faPaperPlane,
  faParking,
  faPhoneAlt,
  faQuestion,
  faQuoteLeft,
  faQuoteRight,
  faTimes
)

css.global('body', {
  background: theme.colors.background,
})

css.global('.js-focus-visible :focus:not([data-focus-visible-added])', {
  outline: 'none',
})

const Layout = ({ children, locale, location }) => (
  <I18nProvider language={locale} catalogs={catalogs}>
    <ThemeProvider theme={theme}>
      <MuiThemeProvider theme={muiTheme}>
        <SnackbarProvider
          iconVariant={{ cookie: '🍪\u00a0\u00a0\u00a0\u00a0' }}
        >
          <StaticQuery
            query={graphql`
              query SiteTitleQuery {
                site {
                  siteMetadata {
                    ogImage
                    ogUrl
                    title
                  }
                }
              }
            `}
            render={({
              site: {
                siteMetadata: { ogImage, ogUrl, title },
              },
            }) => (
              <I18n>
                {({ i18n }) => {
                  const description = i18n._(
                    t`Klinika zabývající se nejen estetikou, ale i běžnou péčí o Vaše zuby.`
                  )

                  return (
                    <>
                      <Helmet>
                        <title>{title}</title>
                        <meta name="description" content={description} />

                        <meta
                          name="keywords"
                          content={Array.from(
                            new Set([
                              'AFI Karlín',
                              'Butterfly',
                              'CAD/CAM',
                              'CEREC',
                              'Karlín',
                              i18n._(t`bělení`),
                              i18n._(t`bílé zuby`),
                              i18n._(t`fazety`),
                              i18n._(t`hollywoodský úsměv`),
                              i18n._(t`implantáty`),
                              i18n._(t`klinika`),
                              i18n._(t`korunky`),
                              i18n._(t`kosmetický zubař`),
                              i18n._(t`můstky`),
                              i18n._(t`nové zuby`),
                              i18n._(t`nový úsměv`),
                              i18n._(t`oprava zubů`),
                              i18n._(t`rekonstrukce chrupu`),
                              i18n._(t`stomatologie`),
                              i18n._(t`úsměv za jeden den`),
                              i18n._(t`zubař`),
                              i18n._(t`zubní lékař`),
                              i18n._(t`zubní ordinace`),
                              i18n._(t`zuby za jeden den`),
                              i18n._(t`zuby`),
                            ])
                          )
                            .sort()
                            .join(', ')}
                        />

                        <meta property="og:title" content={title} />
                        <meta property="og:description" content={description} />
                        <meta property="og:image" content={ogImage} />
                        <meta property="og:url" content={ogUrl} />
                        <meta property="og:type" content="website" />
                      </Helmet>
                      <Header locale={locale} location={location} />
                      <CookieConsent />
                      {children}
                      {/*<footer>&copy; Klika Dent s.r.o., IČO: 07280882</footer>*/}
                    </>
                  )
                }}
              </I18n>
            )}
          />
        </SnackbarProvider>
      </MuiThemeProvider>
    </ThemeProvider>
  </I18nProvider>
)

Layout.propTypes = {
  children: PropTypes.object,
  locale: PropTypes.string.isRequired,
  location: PropTypes.shape(globals.browser.Location).isRequired,
}

export default Layout
